import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';
import { StatusStrip } from './StatusStrip';

/** Top navigation, scrolling content, and an always-visible status strip.
 *  Each view renders its own page header. */
export function AppShell() {
  return (
    <div className="app-shell">
      <TopNav />
      <main className="app-body">
        <Outlet />
      </main>
      <StatusStrip />
    </div>
  );
}
